import type { GetStaticProps } from "next"
import {
  getNewsletterArchive,
  type TeaserArchiveProps,
} from "@/components/resources/data/archives"
import { SiteLayout } from "@/components/resources/layouts/site"
import { CategoryArchive } from "@/components/resources/templates/CategoryArchive"

const Archive = (props: TeaserArchiveProps) => <CategoryArchive {...props} />

Archive.getLayout = SiteLayout

export default Archive

export const getStaticProps: GetStaticProps<TeaserArchiveProps> = async () => {
  const props = await getNewsletterArchive(1)
  return props ? { props, revalidate: 180 } : { notFound: true }
}
